import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getBadges} from '../../../apis/badge/getBadges'

const useQueryBadges = (category?: string) => {
    const {data, refetch} = useQuery({
        queryKey: [...QueryCacheKeys.badge.getBadges(), category],
        queryFn: async () => {
            const {data, pageInfo} = await getBadges(category)
            return {data, pageInfo}
        },
        refetchOnWindowFocus: false,
    })

    return {data, refetch}
}

export default useQueryBadges
